module.exports = __webpack_public_path__ + "media/images/plans/dinner/occation-title-1-633a815ac14309fedc74febde4fc24f3.png";